import React from 'react';
import { connect } from 'react-redux';
import { translate as t, GET_ONE } from 'admin-on-rest';
import plz from 'await-plz';
import { get } from 'lodash';

import ProfileCourseList from './ProfileCourseList';
import { kunal } from '../client';
import kunalClient from '../client/kunalClient';
// import ProfileElearningList from './ProfileElearningList';
import { callApi } from '../client/apiToolbox';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4042/api';
const restClient = kunalClient(API_BASE_URL, kunal);

class PinchoversityResults extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      student: {},
    };
  }

  componentWillMount = async () => { // eslint-disable-line
    const { phoneNumber } = this.props.record;
    const [err, response] = await plz(restClient(GET_ONE, 'students', { id: phoneNumber }));
    if (err) { this.setState({ isLoading: false }); console.log('student fetch fail', err); }
    if (!response) return console.log('No student response data');
    console.log(response);
    this.setState({ student: response.data, isLoading: false });
  }

  removeRegistration = ({ courseId, courseMomentId, phoneNumber }) => {
    callApi(`${API_BASE_URL}/utils/removeCourseRegistration/${courseId}`,
      'PUT',
      { 'Content-Type': 'application/json', credentials: 'include' },
      { phoneNumber, courseMomentId }
    ).then((data) => {
      this.setState({ student: data.json });
    })
      .catch((e) => console.log('RemoveRegistration Student Error', e));
  };

  render() {
    const { isLoading, student } = this.state;
    // const { translate } = this.props;
    return (
      <div>
        {
          isLoading || !student ? null : (
            <div>
              <ProfileCourseList student={student} removeRegistration={this.removeRegistration} {...this.props} />
              {/* <ProfileElearningList student={student} translate={translate} /> */}
            </div>
          )
        }
      </div>
    );
  }
}


export default connect(
  (state) => ({ user: get(state, 'auth.user') }), undefined
)(t(PinchoversityResults));
